import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U3121ProjectContactHandlerReturn } from "./U3121ProjectContactHandlers";
import type { U3121ProjectContact } from "../../../../U3121Service";

interface U3121ProjectContactDeleteDlgProps {
  u3121ProjectContactHandler: U3121ProjectContactHandlerReturn;
  t: TFunction;
  NS: string;
}

function U3121ProjectContactDeleteDlg({ u3121ProjectContactHandler, t, NS }: U3121ProjectContactDeleteDlgProps) {
  if (!u3121ProjectContactHandler.isDeleteDialogOpen) return null;

  return (
    <U2000DeleteRecordDialog
      isOpen={u3121ProjectContactHandler.isDeleteDialogOpen}
      onClose={u3121ProjectContactHandler.onDlgDeleteClose}
      title={t("lblProjectContact", { ns: NS })}
    >
      <p className="mb-4">
        {t("msgDeleteProjectContact", {
          count: u3121ProjectContactHandler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {u3121ProjectContactHandler.gridStateHandlers.getSelectedRows().map((row: U3121ProjectContact, index: number, array: U3121ProjectContact[]) => (
          <span key={row.id} className="inline-block text-gray-800">
            {`${row.contactName ?? ""}`}
            {index < array.length - 1 && ", "}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3121ProjectContactDeleteDlg;
